var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5602",
    "data-name": "Group 5602",
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.164,
    height: 52.164,
    viewBox: "0 0 52.164 52.164",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8237",
    "data-name": "Path 8237",
    d: "M36.258,47.451l2.621,4.561a25.74,25.74,0,0,1-8.126,2.2v-5.3A20.311,20.311,0,0,0,36.258,47.451ZM7.345,30.753H2.05a25.552,25.552,0,0,0,2.2,8.126l4.561-2.621A20.311,20.311,0,0,1,7.345,30.753ZM36.258,8.813l2.621-4.561a25.552,25.552,0,0,0-8.126-2.2v5.3A20.311,20.311,0,0,1,36.258,8.813Zm12.661,16.7h5.3a25.552,25.552,0,0,0-2.2-8.126l-4.561,2.621A20.311,20.311,0,0,1,48.919,25.511ZM20.006,47.451l-2.621,4.561a25.74,25.74,0,0,0,8.126,2.2v-5.3A20.311,20.311,0,0,1,20.006,47.451Zm5.5-40.106V2.05a25.552,25.552,0,0,0-8.126,2.2l2.621,4.561A20.311,20.311,0,0,1,25.511,7.345ZM44.8,15.471l4.561-2.648a26.7,26.7,0,0,0-5.95-5.95l-2.648,4.561A21.03,21.03,0,0,1,44.8,15.471ZM8.813,20.006,4.252,17.385a25.552,25.552,0,0,0-2.2,8.126h5.3A20.311,20.311,0,0,1,8.813,20.006ZM48.919,30.753a20.311,20.311,0,0,1-1.468,5.5l4.561,2.621a25.74,25.74,0,0,0,2.2-8.126ZM40.793,44.8l2.648,4.561a26.7,26.7,0,0,0,5.95-5.95L44.83,40.767A21.03,21.03,0,0,1,40.793,44.8ZM15.471,11.46,12.85,6.873A26.273,26.273,0,0,0,6.9,12.85L11.46,15.5A20.183,20.183,0,0,1,15.471,11.46ZM11.46,40.793,6.9,43.414a26.7,26.7,0,0,0,5.95,5.95L15.5,44.8A20.183,20.183,0,0,1,11.46,40.793ZM28.132,15.025h0a2.629,2.629,0,0,0-2.621,2.621v9.41a5.154,5.154,0,0,0,1.547,3.7l7.864,7.864a2.61,2.61,0,0,0,3.7,0h0a2.61,2.61,0,0,0,0-3.7l-7.864-7.864v-9.41A2.629,2.629,0,0,0,28.132,15.025Z",
    transform: "translate(-2.05 -2.05)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartTimeIcon);
export default __webpack_public_path__ + "static/media/part_time_icon.36f46994588963927d3a856932cf65cd.svg";
export { ForwardRef as ReactComponent };